import { get } from "../../utils";
import { endpointConstants } from "../constants";

export const yodaMaintenanceService = {
  getInfoMaintenance,
};

function getInfoMaintenance() {
  let endpoint = endpointConstants.YODACATALOGUE.MAINTENANCE;
  return get(endpoint);
}
